import React from 'react';
import { T, fonts } from '../../theme/tokens';

export function Quadrant({ d100, r100, label }) {
  const x = 26 + (d100 / 100) * 248;
  const y = 274 - (r100 / 100) * 248;

  return (
    <svg viewBox="0 0 300 300" style={{ width: "100%", maxWidth: 320 }}>
      <defs>
        <radialGradient id="qg" cx="50%" cy="50%" r="70%">
          <stop offset="0%" stopColor={T.accent} stopOpacity="0.08" />
          <stop offset="100%" stopColor={T.accent} stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect x="26" y="26" width="248" height="248" rx="0" fill="url(#qg)" stroke={T.borderMid} />
      <line x1="150" y1="26" x2="150" y2="274" stroke={T.borderMid} strokeDasharray="3 5" />
      <line x1="26" y1="150" x2="274" y2="150" stroke={T.borderMid} strokeDasharray="3 5" />
      {/* axis labels */}
      <text
        x="150"
        y="291"
        textAnchor="middle"
        fill={T.textMid}
        fontSize="9"
        fontFamily={fonts.body}
        fontWeight="600"
        letterSpacing="1.5px"
      >
        DIRECTION →
      </text>
      <text
        x="14"
        y="150"
        textAnchor="middle"
        fill={T.textMid}
        fontSize="9"
        fontFamily={fonts.body}
        fontWeight="600"
        letterSpacing="1.5px"
        transform="rotate(-90 14 150)"
      >
        READINESS →
      </text>
      {/* corner whispers */}
      <text x="40" y="44" fill={T.textMid} fontSize="9" fontFamily={fonts.body} fontWeight="500">
        Quiet Achiever
      </text>
      <text
        x="260"
        y="44"
        textAnchor="end"
        fill={T.textMid}
        fontSize="9"
        fontFamily={fonts.body}
        fontWeight="500"
      >
        Scaler / Primed
      </text>
      <text x="40" y="266" fill={T.textMid} fontSize="9" fontFamily={fonts.body} fontWeight="500">
        Evaluator
      </text>
      <text
        x="260"
        y="266"
        textAnchor="end"
        fill={T.textMid}
        fontSize="9"
        fontFamily={fonts.body}
        fontWeight="500"
      >
        Experimenter
      </text>
      {/* point */}
      <circle cx={x} cy={y} r="9" fill={T.accent} opacity="0.25">
        <animate attributeName="r" values="9;15;9" dur="2.4s" repeatCount="indefinite" />
      </circle>
      <circle cx={x} cy={y} r="6" fill={T.accent} stroke={T.cream} strokeWidth="1.5" />
      {label && (
        <text
          x={x}
          y={y - 14}
          textAnchor="middle"
          fill={T.textDark}
          fontSize="10.5"
          fontFamily={fonts.display}
          fontWeight="600"
        >
          {label}
        </text>
      )}
    </svg>
  );
}
